"use client";
import React, { useState } from 'react';
import { useAdminMute } from './AdminMuteProvider';

interface MutePersonButtonProps {
  userId: string;
  userName: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const MutePersonButton: React.FC<MutePersonButtonProps> = ({ 
  userId, 
  userName, 
  className = '',
  size = 'sm'
}) => {
  const { isAdmin, isUserMuted, muteUser, unmuteUser } = useAdminMute();
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reason, setReason] = useState('');

  if (!isAdmin) return null;

  const isMuted = isUserMuted(userId);

  const handleMute = () => {
    if (isMuted) {
      unmuteUser(userId);
    } else {
      setShowReasonModal(true);
    }
  };

  const handleConfirmMute = () => {
    muteUser(userId, userName, reason || 'Posts van deze gebruiker worden verborgen');
    setShowReasonModal(false);
    setReason('');
  };

  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };

  return (
    <>
      <button
        onClick={handleMute}
        className={`${sizeClasses[size]} rounded-full flex items-center justify-center transition-all duration-200 ${
          isMuted 
            ? 'bg-red-500 text-white hover:bg-red-600' 
            : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
        } ${className}`}
        title={isMuted ? `Unmute ${userName}` : `Mute ${userName}`}
      >
        {isMuted ? '🔇' : '🔊'}
      </button>

      {/* Reason Modal */}
      {showReasonModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              🔇 Persoon Dempen
            </h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Gebruiker: {userName}
                </label>
                <p className="text-sm text-gray-600">
                  Posts van deze persoon worden verborgen voor alle gebruikers tot je hem weer activeert.
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Reden (optioneel)
                </label>
                <textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                  rows={3}
                  placeholder="Bijv. Ongepaste content, Spam, Tijdelijk onderhoud..."
                />
              </div>

              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <div className="text-sm text-red-700">
                  <p className="font-medium mb-1">⚠️ Let op:</p>
                  <p>Alle posts van {userName} worden verborgen voor alle gebruikers.</p>
                </div>
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => {
                  setShowReasonModal(false);
                  setReason('');
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors"
              >
                Annuleren
              </button>
              <button
                onClick={handleConfirmMute}
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                Dempen
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

















